export default __webpack_public_path__ + "static/media/icon-search-outlined.7688bdf0.svg";